namespace Gamification.Gamification {
    export interface RisorseRow {
        IdRisorsa?: number;
        UserId?: number;
        TenantId?: number;
        IdTipologiaRisorsa?: number;
        IdEstensione?: number;
        IdTipologiaCaricamento?: number;
        IdentifierRisorsa?: string;
        Nome?: string;
        Descrizione?: string;
        NomeFileAssetBundle?: string;
        PathFileAssetBundle?: string;
        VersioneAssetBundle?: number;
        UrlAssetBundle?: string;
        IsUrlAssetBundleEsterno?: number;
        NomeFileCoverAssetBundle?: string;
        PathFileCoverAssetBundle?: string;
        UrlCoverAssetBundle?: string;
        IsUrlCoverAssetBundleEsterno?: number;
        NomeFileManifestAssetBundle?: string;
        PathFileManifestAssetBundle?: string;
        UrlManifestAssetBundle?: string;
        IsUrlManifestAssetBundleEsterno?: number;
        AssetPath?: string;
        Escludi?: number;
        IdTipologiaRisorseNome?: string;
        IdTipologiaCaricamentoNome?: string;
    }

    export namespace RisorseRow {
        export const idProperty = 'IdRisorsa';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Risorse';
        export const lookupKey = 'Gamification.Risorse';

        export function getLookup(): Q.Lookup<RisorseRow> {
            return Q.getLookup<RisorseRow>('Gamification.Risorse');
        }
        export const deletePermission = 'Gamification:Risorse';
        export const insertPermission = 'Gamification:Risorse';
        export const readPermission = 'Gamification:Risorse';
        export const updatePermission = 'Gamification:Risorse';

        export declare const enum Fields {
            IdRisorsa = "IdRisorsa",
            UserId = "UserId",
            TenantId = "TenantId",
            IdTipologiaRisorsa = "IdTipologiaRisorsa",
            IdEstensione = "IdEstensione",
            IdTipologiaCaricamento = "IdTipologiaCaricamento",
            IdentifierRisorsa = "IdentifierRisorsa",
            Nome = "Nome",
            Descrizione = "Descrizione",
            NomeFileAssetBundle = "NomeFileAssetBundle",
            PathFileAssetBundle = "PathFileAssetBundle",
            VersioneAssetBundle = "VersioneAssetBundle",
            UrlAssetBundle = "UrlAssetBundle",
            IsUrlAssetBundleEsterno = "IsUrlAssetBundleEsterno",
            NomeFileCoverAssetBundle = "NomeFileCoverAssetBundle",
            PathFileCoverAssetBundle = "PathFileCoverAssetBundle",
            UrlCoverAssetBundle = "UrlCoverAssetBundle",
            IsUrlCoverAssetBundleEsterno = "IsUrlCoverAssetBundleEsterno",
            NomeFileManifestAssetBundle = "NomeFileManifestAssetBundle",
            PathFileManifestAssetBundle = "PathFileManifestAssetBundle",
            UrlManifestAssetBundle = "UrlManifestAssetBundle",
            IsUrlManifestAssetBundleEsterno = "IsUrlManifestAssetBundleEsterno",
            AssetPath = "AssetPath",
            Escludi = "Escludi",
            IdTipologiaRisorseNome = "IdTipologiaRisorseNome",
            IdTipologiaCaricamentoNome = "IdTipologiaCaricamentoNome"
        }
    }
}
